export type AccessRole =
  | 'ADMIN'
  | 'MODERATOR'
  | 'CURATOR'
  | 'SUPPORT'
  | 'CLIENT'
  | 'GUEST';

export type UserAccountType = 'COLLABORATOR' | 'CLIENT';

export const ACCESS_ROLE_LEVEL: Record<AccessRole, number> = {
  ADMIN: 100,
  MODERATOR: 80,
  CURATOR: 60,
  SUPPORT: 40,
  CLIENT: 20,
  GUEST: 10,
};

export const ACCESS_ROLE_LABEL: Record<AccessRole, string> = {
  ADMIN: 'Admin',
  MODERATOR: 'Moderador',
  CURATOR: 'Curador',
  SUPPORT: 'Atendimento',
  CLIENT: 'Cliente',
  GUEST: 'Visitante',
};

export const USER_ACCOUNT_TYPE_LABEL: Record<UserAccountType, string> = {
  COLLABORATOR: 'Colaborador',
  CLIENT: 'Cliente',
};

export const USER_STATUS_LABEL: Record<string, string> = {
  ACTIVE: 'Ativo',
  BLOCKED: 'Bloqueado',
  INACTIVE: 'Bloqueado',
  PENDING: 'Pendente',
};

export const PROFILE_FILTER_OPTIONS: { value: AccessRole; label: string }[] = [
  { value: 'MODERATOR', label: ACCESS_ROLE_LABEL.MODERATOR },
  { value: 'SUPPORT', label: ACCESS_ROLE_LABEL.SUPPORT },
  { value: 'CLIENT', label: ACCESS_ROLE_LABEL.CLIENT },
  { value: 'CURATOR', label: ACCESS_ROLE_LABEL.CURATOR },
  { value: 'GUEST', label: ACCESS_ROLE_LABEL.GUEST },
  { value: 'ADMIN', label: ACCESS_ROLE_LABEL.ADMIN },
];

export const TYPE_FILTER_OPTIONS: { value: UserAccountType; label: string }[] = [
  { value: 'COLLABORATOR', label: USER_ACCOUNT_TYPE_LABEL.COLLABORATOR },
  { value: 'CLIENT', label: USER_ACCOUNT_TYPE_LABEL.CLIENT },
];

export const STATUS_FILTER_OPTIONS = [
  { value: 'ACTIVE', label: 'Ativo' },
  { value: 'PENDING', label: 'Pendente' },
  { value: 'BLOCKED', label: 'Bloqueado' },
] as const;

export const ADMIN_COLLABORATOR_ROLES: AccessRole[] = [
  'ADMIN',
  'SUPPORT',
  'CURATOR',
  'MODERATOR',
  'GUEST',
];

export const MODERATOR_COLLABORATOR_ROLES: AccessRole[] = [
  'SUPPORT',
  'CURATOR',
  'GUEST',
];
